import PropTypes from 'prop-types';
import React from 'react';

import './DDCPlayerVideoComponent.scss';

class IFrameVideoComponent extends React.Component {
	render() {
		if (this.props.video) {
			const {
				video: { src, provider },
				widgetInfo: { accountId },
				modalSettings: { videoIsOpen }
			} = this.props;

			const wrapperClassNames = new Set([
				'h-100',
				'd-flex',
				'justify-content-center',
				'align-items-center',
				'video-container',
				'py-5'
			]);

			const playerClassNames = [
				'd-flex',
				'justify-content-center',
				'align-items-center'
			];

			if (!videoIsOpen) {
				wrapperClassNames.add('hide');
				wrapperClassNames.delete('d-flex');
			}

			return (
				<div className={[...wrapperClassNames].join(' ')}>
					<iframe
						src={`${src}`}
						title="dcpaisIframe"
						className={playerClassNames.join(' ')}
						data-accountid={`${accountId}`}
						data-provider={`${provider}`}
					/>
				</div>
			);
		}

		// No video - nothing to see here
		return null;
	}
}

IFrameVideoComponent.propTypes = {
	widgetInfo: PropTypes.shape({
		accountId: PropTypes.string
	}).isRequired,
	video: PropTypes.shape({
		src: PropTypes.string,
		provider: PropTypes.string
	}).isRequired,
	modalSettings: PropTypes.shape({
		videoIsOpen: PropTypes.bool
	}).isRequired
};

export default IFrameVideoComponent;
